import { formatCurrency } from "../../utils";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { resetFreeRounds } from "../../store/slices/free-rounds";
import { ModalProps } from "./Modal";
import Message from "./Message";

const FreeRounds: React.FC<ModalProps> = ({ shown }) => {
  const dispatch = useAppDispatch();
  const currency = useAppSelector((state) => state.details.currency);
  const { amount, active, totalWin } = useAppSelector((state) => {
    return { ...state.freeRounds };
  });

  // const message = totalWin > 0 ? "freeroundsendwin" : "freeroundsend";
  const message = "freeroundsend"; 
  const placeholderValues = [formatCurrency(totalWin, currency)];
  const onHideEnd = () => dispatch(resetFreeRounds());

  return (
    <Message
      shown={shown && active && amount === 0}
      icon="Info"
      message={message}
      placeholderValues={placeholderValues}
      onHideEnd={onHideEnd}
    />
  );
};

export default FreeRounds;
